import Icon from "@ant-design/icons";

const SVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor">
    <title></title>
    <path
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M18.5 4C18.1021 4 17.7205 4.15807 17.4391 4.43944L16.6462 5.23233L18.768 7.35412L19.5609 6.56122C19.8423 6.27986 20.0003 5.89824 20.0003 5.50033C20.0003 5.10242 19.8423 4.7208 19.5609 4.43944C19.2795 4.15807 18.8979 4 18.5 4ZM20.9751 7.97544C21.6315 7.319 22.0003 6.42868 22.0003 5.50033C22.0003 4.57198 21.6315 3.68166 20.9751 3.02522C20.3187 2.36878 19.4283 2 18.5 2C17.5717 2 16.6813 2.36878 16.0249 3.02522L14.5254 4.5247C14.5252 4.52488 14.5256 4.52453 14.5254 4.5247C14.5252 4.52488 14.5245 4.52557 14.5244 4.52574L2.29289 16.7572C2.10536 16.9448 2 17.1991 2 17.4643V21.0363C2 21.5886 2.44772 22.0363 3 22.0363H6.5C6.76522 22.0363 7.01957 21.931 7.20711 21.7434L20.9751 7.97544ZM17.3538 8.76833L15.232 6.64654L4 17.8785V20.0363H6.08579L17.3538 8.76833Z"
    />
  </svg>
);

const EditIcon = (props) => <Icon component={SVG} {...props} />;

export default EditIcon;